import { themeColors } from "../../config.js";

export default {
  frame: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "stretch",
    alignSelf: "stretch",
  },
  sideBar: {
    width: 100,
    background: themeColors.optionColor,
    justifyContent: "flex-start",
    alignItems: "stretch",
    overflow: "auto",
  },
  sideBarEntry: {
    height: 30,
    width: 100,
    justifyContent: "center",
    alignItems: "center",
    color: themeColors.optionTextColor,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: themeColors.transparentWhite,
  },
  page: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    backgroundColor: themeColors.transparentBlack,
    color: themeColors.optionTextColor,
    padding: 20,
    alignItems: "center",
    overflow: "auto",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "stretch",
    width: "80%",
    maxWidth: 400,
  },
  title: {
    fontWeight: "bold",
    fontSize: 18,
    margin: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 5,
  },
  picture: {
    width: 100,
    height: 50,
    borderWidth: 2,
    borderStyle: "solid",
  },
};
